import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import ActivityCategorymasterInput from "../../../components/ActivityMasterInput/ActivityCategorymasterInput";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import {
  getActivityCategory,
  getOneActivityCategory,
} from "../../../utils/ApiCalls/Mobile/ActivityMasters";

const EditActivityMaster = () => {
  const params = useParams();
  const [activityCategory, setActivityCategory] = useState({});
  const [vesselData, setVesselData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Categories",
      route: "/shore/mobile-masters/activity-categories",
    },
    {
      title: "Edit Categories",
      route: "/shore/mobile-masters/activity-categories/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getOneActivityCategory(value);

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });

    setActivityCategory(data.data);
    setVesselData(data?.vesselData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Categories"}>
      <CustomHeaderTitle title={"Edit Categories"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Categories"}
      ></HeaderBread>
      {activityCategory && (
        <ActivityCategorymasterInput
          activityCategory={activityCategory}
          vesselData={vesselData}
        />
      )}
    </Layout>
  );
};

export default EditActivityMaster;
